import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import type { Config } from '..';
import content from '../../../../.contentlayer/generated/PrivacyPolicy/privacyPolicy__de-DE.mdx.json';

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout },
  seo: {
    ...sharedConfig['de-DE'].seo,
    title: 'Persönliche Daten | Lemonade',
    metaTitle: 'Persönliche Daten | Lemonade',
    description:
      'Die Sicherheit deiner persönlichen Daten ist uns unglaublich wichtig und wir investieren viel Mühe in den Schutz deiner Daten.',
  },
  MDXContent: content as DocumentTypes,
};
